<template>
  <div>
    <h1 class="page-header"></h1>
    <div class="row">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between">
          <h1 class="page-header">
            {{ $t('disciplinaryRecord.pageTitle') }}
          </h1>
          <ts-breadcrumb :items="[
            { text: $t('toHomePage'), href: '/' },
            { text: $t('disciplinaryRecord.pageTitle'), active: true }
          ]" />
        </div>
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start">
                <ts-button color="info" outline @click="addNew">
                  {{ $t('add_new') }}
                </ts-button>
              </div>
              <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
                <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px" class="kh-font" />
                <ts-button outline class="ml-2" v-tooltip="$t('disciplinaryRecord.filter')"
                  @click.prevent="visible = true">
                  <i class="fa fa-filter"></i>
                </ts-button>
              </div>
            </div>
            <a-drawer :title="$t('invoice.filter')" placement="right" :closable="false" :visible="visible"
              @close="onCloseDrawer" :zIndex="1020" width="300px">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{
                      $t('disciplinaryRecord.disciplinarySubType')
                    }}</label>
                    <a-select style="width: 257px" v-model="dis_sub_type_id" :options="subTypes" showSearch
                      mode="multiple" :filterOption="(input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                        " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
                    </a-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{
                      $t('disciplinaryRecord.disciplinaryActivity')
                    }}</label>
                    <a-select style="width: 257px" v-model="dis_activity_id" :options="activities" showSearch
                      mode="multiple" :filterOption="(input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                        " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
                    </a-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{ $t('disciplinaryRecord.actionDate') }}</label>
                    <a-range-picker format="DD-MM-YYYY" :defaultValue="rangeDate" :defaultPickerValue="rangeDate"
                      @change="dateRangeChange">
                      <template slot="renderExtraFooter"></template>
                    </a-range-picker>
                  </div>
                </div>
              </div>
            </a-drawer>
          </ts-card-wrapper>
          <div class="scrollable">
            <!-- <ts-table :columns="columns" :records="resources" :loading="loading">
              <template v-slot="{ record }">
                <td>{{ record.student ? record.student.card_number : '' }}</td>
                <td class="ts-whitespace-no-wrap">{{ record.student ? record.student.full_name_en : '' }}</td>
                <td class="text-center ts-whitespace-no-wrap">
                  {{ record.student ? record.student.gender : '' }}
                </td>
                <td>
                  {{
                    record.disciplinary_sub_type
                    ? record.disciplinary_sub_type.dis_sub_type_en +
                    '|' +
                    record.disciplinary_sub_type.dis_sub_type_kh
                    : ''
                  }}
                </td>
                <td>
                  {{
                    record.disciplinary_sub_type.att_status
                    ? record.disciplinary_sub_type.att_status.remark + ' ' +
                    '(' + record.disciplinary_sub_type.att_status.att_status + ')'
                    : ''
                  }}
                </td>
                <td class="text-center">{{ record.number_of_discipline }}</td>
                <td>{{ record.dis_action_date }}</td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.student_subject ? record.student_subject.subject_name_foreign : '' }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{
                    record.disciplinary_activity
                    ? record.disciplinary_activity.dis_activity_en + '|'
                    : ''
                  }}
                  {{
                    record.disciplinary_activity
                    ? record.disciplinary_activity.dis_activity_kh
                    : ''
                  }}</td>
                <td class="ts-whitespace-no-wrap">
                  {{
                    record.disciplinary_activity
                    ? record.disciplinary_activity.penalties.penalty_type_en + '|'
                    : ''
                  }}
                  {{
                    record.disciplinary_activity
                    ? record.disciplinary_activity.penalties.penalty_type_kh
                    : ''
                  }}
                </td>
                <td class="text-center">{{ record.penalty_unit }}</td>
                <td class="ts-whitespace-no-wrap">{{ record.dis_action_description }}</td>
                <td class="text-center">
                  <a href="#" v-tooltip="$t('pdf')" class="text-danger mr-2">
                    <i class="fas fa-file-pdf"></i>
                  </a>
                  <a href="#" title="edit" class="text-primary mr-2" @click.prevent="edit(record)">
                    <i class="fas fa-edit"></i>
                  </a>
                  <a href="#" title="delete" class="text-danger" @click.prevent="destroy(record.dis_record_id)">
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </template>
            </ts-table> -->
            <ts-table :columns="columns" :records="resources" :loading="loading">
              <template v-slot="{ record }">
                <td>{{ record.card_number }}</td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.student_name_en }}
                </td>
                <td class="text-center ts-whitespace-no-wrap">
                  {{ record.student ? record.student.gender : '' }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.dis_sub_type_en + '|' + record.dis_sub_type_kh }}
                </td>
                <td>
                  {{
                    record.penalty_type_en == null
                    ? ''
                    : record.remark + ' ' + '(' + record.att_status + ')'
                  }}
                </td>
                <td class="text-center">{{ record.number_of_discipline }}</td>
                <td>{{ record.dis_action_date }}</td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.subject_name_foreign }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.dis_activity_en + '|' }}
                  {{ record.dis_activity_kh }}
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{
                    record.penalty_type_en == null
                    ? ''
                    : record.penalty_type_en + '|'
                  }}
                  {{ record.penalty_type_kh }}
                </td>
                <td class="text-center">{{ record.penalty_unit }}</td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.dis_action_description }}
                </td>
                <td class="text-center">
                  <a href="#" v-tooltip="$t('pdf')" class="text-danger mr-2" @click.prevent="pdfView(record)">
                    <i class="fas fa-file-pdf"></i>
                  </a>
                  <a href="#" title="edit" class="text-primary mr-2" @click.prevent="edit(record)"
                    v-show="record.penalty_type_id == null">
                    <i class="fas fa-edit"></i>
                  </a>
                  <a href="#" title="delete" class="text-danger" @click.prevent="destroy(record.dis_record_id)"
                    v-show="record.penalty_type_id == null">
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </template>
            </ts-table>
          </div>
          <a-modal v-if="showForm" v-model="showForm" :title="$t('disciplinaryRecord.pageTitle')" centered
            :maskClosable="false" @cancel="fetchData" :zIndex="1020" :footer="null" width="1080px">
            <form-create @cancel="() => (showForm = false)" @fetchData="fetchData" :edit="edit_data"
              @success_update="edit_data = ''"></form-create>
          </a-modal>
          <a-modal :title="$t('pdf')" width="70%" v-model="show_pdf" :footer="null">
            <ts-preview-pdf v-model="waiting" :src="src" />
          </a-modal>
          <ts-card-wrapper class="d-flex justify-content-end p-15">
            <ts-pagination v-model="pagination" @navigate="fetchData">
            </ts-pagination>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'
import moment from 'moment'
import PreviewPdf from './preview-pdf'

export default {
  components: {
    FormCreate
  },
  name: 'disciplinary-record',
  props: ['editData'],
  data() {
    return {
      edit_data: this.editData,
      loading: false,
      visible: false,
      showForm: false,
      waiting: false,
      src: '',
      show_pdf: false,
      rangeDate: [moment().add(-7, 'Day'), moment()],
      subTypes: [],
      activities: [],
      columns: [
        { name: this.$t('disciplinaryRecord.cardNumber') },
        { name: this.$t('disciplinaryRecord.studentName') },
        {
          name: this.$t('disciplinaryRecord.sex'),
          style: 'width: 8%; text-align:center'
        },
        {
          name: this.$t('disciplinaryRecord.disciplinarySubType')
        },
        {
          name: this.$t('disciplinaryRecord.attStatus')
        },
        {
          name: this.$t('disciplinaryRecord.numberOfDiscipline')
        },
        {
          name: this.$t('disciplinaryRecord.actionDate')
        },
        {
          name: this.$t('disciplinaryRecord.subjectName')
        },
        {
          name: this.$t('disciplinaryRecord.disciplinaryActivity')
        },
        {
          name: this.$t('disciplinaryRecord.penaltyType')
        },
        {
          name: this.$t('disciplinaryRecord.penaltyUnit')
        },
        {
          name: this.$t('disciplinaryRecord.description')
        },
        {
          name: this.$t('actions'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  created() {
    this.fetchData()
    this.fetchSubType()
    this.fetchActivity()
  },
  computed: {
    ...mapState('disciplinaryRecord', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.disciplinaryRecord.search
      },
      set(newVal) {
        this.$store.commit('disciplinaryRecord/SET_SEARCH', newVal)
        this.$store.commit('disciplinaryRecord/RESET_CURRENT_PAGE')
      }
    },
    dis_sub_type_id: {
      get() {
        return this.$store.state.disciplinaryRecord.dis_sub_type_id
      },
      set(newValue) {
        this.$store.commit('disciplinaryRecord/SET_DIS_SUB_TYPE_ID', newValue)
      }
    },
    dis_activity_id: {
      get() {
        return this.$store.state.disciplinaryRecord.dis_activity_id
      },
      set(newValue) {
        this.$store.commit('disciplinaryRecord/SET_DIS_ACTIVITY_ID', newValue)
      }
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    onCloseDrawer() {
      this.visible = false
    },
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('disciplinaryRecord/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    fetchSubType() {
      this.loading = true
      this.$store
        .dispatch('disciplinaryRecord/getSubType')
        .then(response => {
          this.subTypes = response[1].map(el => ({
            value: el.dis_sub_type_id,
            label: el.dis_sub_type_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    fetchActivity() {
      this.loading = true
      this.$store
        .dispatch('disciplinaryRecord/getActivity')
        .then(response => {
          this.activities = response[1].map(el => ({
            value: el.dis_activity_id,
            label: el.dis_activity_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },

    dateRangeChange(dateRange) {
      this.$store.commit(
        'disciplinaryRecord/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'disciplinaryRecord/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },

    pdfView(record) {
      this.$modal.show(
        PreviewPdf,
        {
          url: null,
          penalty_type_id: record.penalty_type_id,
          dis_record_id: record.dis_record_id,
          dis_sub_type_id: record.dis_sub_type_id,
          dis_sub_type_en: record.dis_sub_type_en,
          subject_id: record.subject_id
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    edit(data) {
      this.edit_data = data
      this.$router.push(`/disciplinary-records/${data.dis_record_id}`)
      this.showForm = true
    },

    async destroy(id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('disciplinaryRecord/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    dis_sub_type_id: debounce(function (value) {
      this.fetchData({ dis_sub_type_id: value })
    }, 500),
    dis_activity_id: debounce(function (value) {
      this.fetchData({ dis_activity_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'disciplinary-record-create') {
      this.$store.commit('disciplinaryRecord/RESET_STATE')
    }
    next()
  }
}
</script>
<style>
.scrollable {
  width: 100%;
  overflow-x: scroll;
}
</style>
